module.exports = __webpack_public_path__ + "img/3.8e9a0fab.png";